import { render } from "./ConversationsListVirtual.vue?vue&type=template&id=3a853964&scoped=true"
import script from "./ConversationsListVirtual.vue?vue&type=script&lang=js"
export * from "./ConversationsListVirtual.vue?vue&type=script&lang=js"

import "./ConversationsListVirtual.vue?vue&type=style&index=0&id=3a853964&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a853964"]])

export default __exports__